import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  ViewChild
} from "@angular/core";
import { MatTabGroup } from "@angular/material/tabs";
import { BehaviorSubject, Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ModalMaterialComponent } from "@onsip/web/features/shared/components/modal/modal-material.component";
import { take } from "rxjs/operators";
import { ParkingLotWithExt } from "@onsip/web/features/administrators/parkingLot/parkingLotPage/parking-lot-page.component";

@Component({
  selector: "onsip-parking-lot-shelf-container",
  templateUrl: "./parking-lot-shelf-container.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ParkingLotShelfContainerComponent implements OnDestroy {
  @ViewChild(MatTabGroup) matTabGroup!: MatTabGroup;

  @Input() parkLot!: ParkingLotWithExt;
  @Input() parkChannelPrice!: string;
  expansionModuleName = "";
  settingsView = new BehaviorSubject<"view" | "edit">("view");
  callerSettingsView = new BehaviorSubject<"view" | "edit">("view");
  private prevSelectedIndex = 0;
  private mode: "view" | "edit" = "view";
  private unsubscriber = new Subscription();

  constructor(
    private dialog: MatDialog,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef
  ) {}

  onSelectedIndexChange(event: number) {
    if (this.mode === "edit" && this.matTabGroup.selectedIndex !== this.prevSelectedIndex) {
      this.matTabGroup.selectedIndex = this.prevSelectedIndex;
      const modal = this.dialog.open(ModalMaterialComponent, {
        panelClass: ["mat-typography", "onsip-dialog-universal-style"],
        data: {
          title: this.translate.instant("ONSIP_I18N.CANCEL_EDITS"),
          message: this.translate.instant("ONSIP_I18N.ANY_CHANGES_YOU_HAVE_MADE_WILL_NOT_BE_SAVED"),
          primaryBtnText: this.translate.instant("ONSIP_I18N.OK"),
          secondaryBtnText: this.translate.instant("ONSIP_I18N.KEEP_EDITING"),
          primaryBtnFlat: true
        }
      });

      this.unsubscriber.add(
        modal
          .afterClosed()
          .pipe(take(1))
          .subscribe(retObj => {
            if (retObj && retObj.doPrimaryAction) {
              this.toggleParkLotSettingsPanel("view");
              this.toggleCallerSettingsPanel("view");
              this.prevSelectedIndex = this.matTabGroup.selectedIndex || 0;
              this.matTabGroup.selectedIndex = event;
              this.cdRef.markForCheck();
            } else if (retObj && !retObj.doPrimaryAction) {
              this.mode = "edit"; // pressed "keep editing"
            }
          })
      );
    } else {
      this.mode = "view";
      this.prevSelectedIndex = this.matTabGroup.selectedIndex || 0;
      this.matTabGroup.selectedIndex = event;
    }
  }

  toggleParkLotSettingsPanel(panel: "view" | "edit"): void {
    this.settingsView.next(panel);
    this.mode = panel;
  }

  toggleCallerSettingsPanel(panel: "view" | "edit"): void {
    this.callerSettingsView.next(panel);
    this.mode = panel;
  }

  ngOnDestroy(): void {
    this.unsubscriber.unsubscribe();
  }
}
